<template>
    <div class="home-div">
        <SideBar/>
        <div class="component-container">
          <div v-if="InstrList.length === 0" class="no-data font-color-1">工具集加载中，请稍后~</div>
          <div class="instr-div" v-for="item in InstrList" :key="item.id">
            <div class="item-title font-color-5">{{ item.typeName }}</div>
              <div class="item-div font-color-4 mbl" @click="openInstrLink(itemChild.link, itemChild.enableJump, itemChild.componentName)" style="cursor:pointer;" v-for="itemChild in item.dataList" :key="itemChild.id">
                <img class="item-img" :src=baseFileUrl+itemChild.img />
                <div style="font-size: 16px;">{{ itemChild.desc }}</div>
              </div>
          </div>
        </div>
        <BottomTip/>
        <WordToPDF
          :isVisible="showWordToPdf"
          @close="handleShow('showWordToPdf')"
          @update:visible="showWordToPdf = $event"/>

          <PdfToWord
          :isVisible="showPdfToWord"
          @close="handleShow('showPdfToWord')"
          @update:visible="showPdfToWord = $event"/>
    </div>
</template>

<script>

import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import JsonTrans from '@/components/instr/JsonTrans.vue';
import WordToPDF from '@/components/instr/WordToPDF.vue';
import PdfToWord from '@/components/instr/PdfToWord.vue';

import { getInstrList } from '@/api/instr';
import config from '@/utils/Config';


export default {
  name: 'Instr',
  components: {
    SideBar,
    BottomTip,
    JsonTrans,
    WordToPDF,
    PdfToWord
  },
  data(){
    return{
      baseFileUrl: config.BASE_FILE_URL,
      InstrList: [],

      showWordToPdf: false,
      showPdfToWord: false,
    }
  },
  mounted(){
    this.getGInstrList();
  },
  methods:{

    handleShow(event){
      if(event === "showWordToPdf"){
        this.showWordToPdf = !this.showWordToPdf;
        return;
      }
      if(event === "showPdfToWord"){
        this.showPdfToWord = !this.showPdfToWord;
        return;
      }
    },
    openInstrLink(linkUrl, enableJump, componentName){
      console.log(componentName)
      if (enableJump === '0'){
        window.open(linkUrl, '_blank');
      }else{
        if(componentName === "showWordToPdf"){
          this.showWordToPdf = !this.showWordToPdf;
          return;
        }
        if(componentName === "showPdfToWord"){
          this.showPdfToWord = !this.showPdfToWord;
          return;
        }
      }
    },

    async getGInstrList(){
      const resp = await getInstrList({});
      if(resp != null && resp.data != null){
        this.InstrList = resp.data
      }
    }
  }
}
</script>

<style scoped>

@media only screen and (max-width: 768px) {
  .item-div {
  width: 44% !important;
  padding: 5px !important;
  margin: 5px 5px !important;
}
.item-img{
  width: 40px !important;
  height: 40px !important;
}
}

.component-container{
  width: 100%;
  min-height: 100vh;
}

.no-data{
  width: 100%; 
  height: 100vh;
  display: flex; 
  justify-content: center;
  align-content: center;
  padding-top: 200px;
}

.item-title{
  width: 100%; 
  display: flex; 
  justify-content: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-div {
  width: 150px;
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  margin: 10px 10px;
}
.item-img{
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.instr-div{
  font-size: 18px;
  font-weight: 600;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* padding: 0 10px; */
}
.home-div{
    width: 100%;
    min-height: 100vh;
    margin: 0;
    padding-top: 60px;
    overflow: hidden;
}
</style>